var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 994,
    height: 988,
    viewBox: "0 0 994 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M875.904 870.617H0V0H875.904V870.617Z",
    fill: "#CAE1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M875.904 870.617H437.952V0H875.904V870.617Z",
    fill: "#9FC6E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M994 988H118.096V117.383H994V988Z",
    fill: "#FD4E26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M994 988H556.048V117.383H994V988Z",
    fill: "#D8270F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M746.888 865.197L556.518 675.975L366.147 865.197L242.598 742.393L432.969 553.172L242.598 363.951L366.147 241.147L556.518 430.369L746.888 241.147L870.437 363.951L680.067 553.172L870.437 742.393L746.888 865.197Z",
    fill: "#F5FBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M870.437 363.953L746.888 241.151L556.048 429.905V676.442L746.888 865.197L870.437 742.395L680.067 553.174L870.437 363.953Z",
    fill: "#CAE1F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.de02366d4c026243a864e30add4bb111.svg";
export { ForwardRef as ReactComponent };